<template>
    <div>
        <div class="info-container mb-10 form-container mx-auto">
            <h5 class="text-lg">{{ $trans.get("registration.general-title-btn") }}</h5>
        </div>
        <div class="form-container mx-auto">
            <div class="form-container__inputs">
                <p class="text-sm mb-3">{{ $trans.get('registration.how-know') }}</p>
                <floating-select-input
                  class="w-full"
                  name="knownHow"
                  :title="$trans.get('registration.type-id-title-optional')"
                  :initialValue="form.general.knownHow.value"
                  :options="[
                    { label: $trans.get('registration.internet'), value: 'internet' },
                    { label: $trans.get('registration.friends'), value: 'friend' },
                    { label: $trans.get('registration.school'), value: 'school' },
                    { label: $trans.get('registration.other'), value: 'other' }
                  ]"
                  @handle-change="handleGeneral"
                  required
                />

                <floating-textarea name="comments" :placeholder="$trans.get('registration.comments')" :initialValue="form.general.comments.value"
                    v-model="form.general.comments.value">
                </floating-textarea>
                <div class="col-span-2 flex items-center mt-6 text-sm">
                    <input type="checkbox" id="privacyPolicyAuthorization" name="privacyPolicyAuthorization"
                        @change="handleGeneral({ value: $event.target.checked, name: 'privacyPolicyAuthorization' })"
                        :checked="form.general.privacyPolicyAuthorization.value"
                        required
                        class="w-5 h-5 text-blue-500 border-gray-300 rounded focus:ring-blue-500" />
                    <label for="privacyPolicyAuthorization" class="ml-3 text-gray-700" v-html="$trans.get('registration.privacy-policy-checkbox')"></label>
                </div>
                <div class="col-span-2 flex items-center mt-6 text-sm">
                    <input type="checkbox" id="communicationAuthorization" name="communicationAuthorization"
                        @change="handleGeneral({ value: $event.target.checked, name: 'communicationAuthorization' })"
                        :checked="form.general.communicationAuthorization.value"
                        class="w-5 h-5 text-blue-500 border-gray-300 rounded focus:ring-blue-500" />
                    <label for="communicationAuthorization" class="ml-3 text-gray-700" v-html="$trans.get('registration.communication-authorization')"></label>
                </div>

            </div>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        general: {
            type: Object,
            required: false
        }

    },
    name: "GeneralData",
    data: () => {
        return {
            form: {
                general: {
                    knownHow: {
                        name: "knownHow",
                        value: "friend",
                        errors: [],
                    },
                    comments: {
                        name: "comments",
                        value: "",
                        errors: [],
                    },
                    privacyPolicyAuthorization: {
                        name: "privacyPolicyAuthorization",
                        value: false,
                        errors: [],
                    },
                    communicationAuthorization: {
                        name: "communicationAuthorization",
                        value: false,
                        errors: [],
                    },
                    dataProtection: {
                        name: "dataProtection",
                        value: false,
                        errors: [],
                    },
                }
            }
        }
    },
    methods: {
        handleGeneral({ value, name }) {
            this.form.general[name].value = value;
        },
    },
    created(){
        if(!this.general) return;

        this.form.general.knownHow.value = this.general.knownHow || 'friend';
        this.form.general.comments.value = this.general.comments;
        this.form.general.communicationAuthorization.value = this.general.communicationAuthorization;
        this.form.general.privacyPolicyAuthorization.value = this.general.privacyPolicyAuthorization;
        this.form.general.dataProtection.value = this.general.dataProtection;
    },

}
</script>
<style lang="scss" scoped>
input[type="checkbox"].border-red-500 {
    outline: 1px solid red;
    outline-offset: 0px;
}

</style>
